<template>
  <div class="beiAnContainer">
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      center
      :title="todoType == 'add' ? '新增用户' : '编辑用户'"
      :visible.sync="dialogVisible"
      width="756px"
      custom-class="addoredit"
      @close="close"
    >
      <el-form
        ref="jbxxForm"
        :rules="rules"
        :model="jbxxForm"
        label-width="90px"
      >
        <el-form-item label="姓名:">
          <el-input v-model="jbxxForm.userName" />
        </el-form-item>
        <el-form-item label="身份证号:" label-width="90px">
          <el-input v-model="jbxxForm.idCard" />
        </el-form-item>
        <el-form-item label="归属部门:" prop="deptId">
          <el-cascader
            ref="deptCascader"
            v-model="jbxxForm.deptId"
            :props="{ emitPath: false, checkStrictly: true }"
            :show-all-levels="false"
            style="width: 100%"
            :options="deptList"
          />
        </el-form-item>
        <el-form-item label="手机号码:">
          <el-input v-model="jbxxForm.phonenumber" />
        </el-form-item>
        <el-form-item label="座机号码:">
          <el-input v-model="jbxxForm.telnumber" />
        </el-form-item>
        <el-form-item label="登录账号:" prop="loginName">
          <el-input v-model="jbxxForm.loginName" :disabled="todoType != 'add'" />
        </el-form-item>
        <el-form-item style="width: 100%" label="登录密码:" prop="password">
          <el-input v-model="jbxxForm.password" />
        </el-form-item>
        <el-form-item label="用户性别:">
          <el-select v-model="jbxxForm.sex" style="width: 100%">
            <el-option
              v-for="(item, index) in sexOptions"
              :key="index"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="邮箱:">
          <el-input v-model="jbxxForm.email" />
        </el-form-item>
        <el-form-item label="用户状态:">
          <el-select v-model="jbxxForm.status" style="width: 100%">
            <el-option
              v-for="(item, index) in statusList"
              :key="index"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item style="width: 100%" label="角色:">
          <el-select v-model="jbxxForm.roleIds" multiple style="width: 100%">
            <el-option
              v-for="item in RoleList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
          <!-- <el-checkbox-group v-model="jbxxForm.authority">
            <el-checkbox label="超级管理员"></el-checkbox>
            <el-checkbox label="普通角色"></el-checkbox>
            <el-checkbox label="企业"></el-checkbox>
            <el-checkbox label="企业主管理员"></el-checkbox>
            <el-checkbox label="公安"></el-checkbox>
            <el-checkbox label="查询企业角色"></el-checkbox>
            <el-checkbox label="企业初始化库存角色"></el-checkbox>
            <el-checkbox label="公安管理角色"></el-checkbox>
            <el-checkbox label="审批角色"></el-checkbox>
            <el-checkbox label="审核角色"></el-checkbox>
            <el-checkbox label="进出口省级核查角色"></el-checkbox>
            <el-checkbox label="进出口部级核查角色"></el-checkbox>
            <el-checkbox label="受理角色"></el-checkbox>
          </el-checkbox-group> -->
        </el-form-item>
        <el-form-item label="备注:" style="width: 100%">
          <el-input
            v-model="jbxxForm.remark"
            resize="none"
            rows="3"
            type="textarea"
            placeholder="请输入"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          v-preventReClick
          type="primary"
          @click="submitClick"
        >确 认</el-button>
      </div>
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      center
      title="分配角色"
      :visible.sync="dialogjsVisible"
      width="1200px"
      custom-class="fpuesr"
      @close="close"
    >
      <el-form label-position="left" style="width: 95%; margin: 10px auto">
        <el-form-item label="用户名称:">
          <el-input v-model="jbxxForm.yszlx" />
        </el-form-item>
        <el-form-item label="登录账号:">
          <el-input v-model="jbxxForm.gmxkz" />
        </el-form-item>
      </el-form>
      <div style="width: 95%; margin: 10px auto">分配角色</div>
      <el-table
        stripe
        :data="tableData"
        :row-style="{ height: 0 + 'px' }"
        :header-cell-style="{
          'text-align': 'center',
          background: '#eef1f6',
        }"
        :cell-style="{ 'text-align': 'center' }"
        style="width: 95%; margin: auto"
      >
        <el-table-column type="selection" />
        <el-table-column prop="name" label="角色编号" />
        <el-table-column prop="yhmc" label="排序" />
        <el-table-column
          prop="section"
          label="角色名称"
          show-overflow-tooltip
        />
        <el-table-column prop="sj" label="权限字符" />
        <el-table-column prop="bbdate" label="创建时间" />
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button
          v-preventReClick
          type="primary"
          @click="submitClick"
        >确 认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getRoleKv, AddUser, updateUser } from '@/assets/js/yhgl.js'
export default {
  data() {
    const pwdValidate = (rule, value, callback) => {
      if (value) {
        const reg = new RegExp(/((^(?=.*[a-z])(?=.*[A-Z])(?=.*\W)[\da-zA-Z\W]{8,16}$)|(^(?=.*\d)(?=.*[A-Z])(?=.*\W)[\da-zA-Z\W]{8,16}$)|(^(?=.*\d)(?=.*[a-z])(?=.*\W)[\da-zA-Z\W]{8,16}$)|(^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[\da-zA-Z\W]{8,}$))/)
        if (!reg.test(value)) {
          callback(new Error('密码必须同时包含大写、小写、数字和特殊字符(不包含\'_\')其中三项且至少8位'))
        } else {
          callback()
        }
      } else {
        callback()
      }
    }
    var validateCard = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入身份证号码'))
      } else {
        if (!this.IdentityCodeValid(value)) {
          callback(new Error('请输入正确的身份证号码'))
        } else {
          callback()
        }
      }
    }
    var deptIdValidate = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请选择归属部门'))
      }
      callback()
    }

    return {
      todoType: '', // 操作类型 edit add
      jbxxForm: {}, // 表单
      dialogVisible: false, // 新增或编辑弹窗开关
      dialogjsVisible: false, // 用户分配 此弹窗已弃用
      tableData: [],
      RoleList: [], // 角色下拉框
      sexOptions: [
        // 性别KV
        {
          label: '男',
          value: '0'
        },
        {
          label: '女',
          value: '1'
        },
        {
          label: '未知',
          value: '2'
        }
      ],
      statusList: [
        // 状态KV
        {
          label: '正常',
          value: '0'
        },
        {
          label: '停用',
          value: '1'
        }
      ],
      rules: {
        idCard: [
          { required: true, validator: validateCard, trigger: 'change' }
        ],
        deptId: [
          { required: true, validator: deptIdValidate, trigger: 'change' }
        ],
        loginName: [
          { required: true, message: '请输入登录账号', trigger: 'change' }
        ],
        password: [
          { required: false, validator: pwdValidate, trigger: 'change' }
        ]
      }
    }
  },
  computed: {
    deptList: {
      get() {
        return this.$parent.deptTree
      }
    }
  },
  watch: {
    /* "jbxxForm.deptId"() {
      if (this.$refs.deptCascader) {
        this.$refs.deptCascader.dropDownVisible = false; //监听值发生变化就关闭它
      }
    }, */
  },
  mounted() {
    getRoleKv().then((e) => {
      this.RoleList = e.data.data
    })
    setInterval(function() {
      document.querySelectorAll('.el-cascader-node__label').forEach((el) => {
        el.onclick = function() {
          if (this.previousElementSibling) this.previousElementSibling.click()
        }
      })
    }, 1000)
  },
  methods: {
    IdentityCodeValid(code) {
      // 验证身份证合法性
      var city = {
        11: '北京',
        12: '天津',
        13: '河北',
        14: '山西',
        15: '内蒙古',
        21: '辽宁',
        22: '吉林',
        23: '黑龙江 ',
        31: '上海',
        32: '江苏',
        33: '浙江',
        34: '安徽',
        35: '福建',
        36: '江西',
        37: '山东',
        41: '河南',
        42: '湖北 ',
        43: '湖南',
        44: '广东',
        45: '广西',
        46: '海南',
        50: '重庆',
        51: '四川',
        52: '贵州',
        53: '云南',
        54: '西藏 ',
        61: '陕西',
        62: '甘肃',
        63: '青海',
        64: '宁夏',
        65: '新疆',
        71: '台湾',
        81: '香港',
        82: '澳门',
        91: '国外 '
      }
      var tip = ''
      var pass = true

      var patt1 = new RegExp(
        '(^[1-9]\\d{5}(18|19|([23]\\d))\\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\\d{3}[0-9Xx]$)|(^[1-9]\\d{5}\\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\\d{2}$)'
      )
      if (!code || !patt1.test(code)) {
        tip = '身份证号格式错误'
        pass = false
      } else if (!city[code.substr(0, 2)]) {
        tip = '地址编码错误'
        pass = false
      } else {
        // 18位身份证需要验证最后一位校验位
        if (code.length == 18) {
          code = code.split('')
          // ∑(ai×Wi)(mod 11)
          // 加权因子
          var factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2]
          // 校验位
          var parity = [1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2]
          var sum = 0
          var ai = 0
          var wi = 0
          for (var i = 0; i < 17; i++) {
            ai = code[i]
            wi = factor[i]
            sum += ai * wi
          }
          var last = parity[sum % 11]
          if (parity[sum % 11] != code[17]) {
            tip = '校验位错误'
            pass = false
          }
        }
      }
      return pass
    },
    // 关闭
    close() {
      this.dialogVisible = false
      this.dialogjsVisible = false
      this.jbxxForm = {}
      this.$refs['jbxxForm'].resetFields()
    },
    // 提交
    submitClick() {
      this.$refs['jbxxForm'].validate((valid) => {
        if (valid && this.todoType == 'add') {
          AddUser(this.jbxxForm).then((e) => {
            if (e.data.code == '000000') {
              this.$message.success('用户新增成功!')
              this.dialogVisible = false
              this.dialogjsVisible = false
              this.$parent.loadDatasource()
            }
          })
        } else if (valid && this.todoType == 'edit') {
          updateUser(this.jbxxForm).then((e) => {
            if (e.data.code == '000000') {
              this.$message.success('编辑成功!')
              this.dialogVisible = false
              this.dialogjsVisible = false
              this.$parent.loadDatasource()
            }
          })
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.beiAnContainer {
  /deep/ .addoredit {
    .el-dialog__body {
      padding: 20px 40px;
      .el-form {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        .el-form-item {
          width: 47%;
          .el-form-item__content {
            display: flex;
          }
        }
      }
    }
  }
  /deep/ .fpuesr {
    .el-dialog__body {
      padding: 20px 40px;
      .el-form {
        display: flex;

        .el-form-item {
          width: 30%;
          margin-right: 20px;
          .el-form-item__content {
            display: flex;
          }
        }
      }
    }
  }
  .el-button--primary {
    color: #fff;
    background: #4170ff;
    border-radius: 3px;
    border-color: #4170ff;
  }
}
</style>
